import React, { forwardRef } from 'react'

import * as style from './style.module.sass'

import ArtisanTopHeadline from '../ArtisanTopHeadline'
import ArtisanTopDescription from '../ArtisanTopDescription'
import ArtisanArticleList from '../ArtisanArticlesList'
import MixBlendContainer from '../MixBlendContainer'
import BlurContainer from '../BlurContainer'
import JumpLink from '@molecules/JumpLink'
import { useTranslation } from '@models/Translation'
import { useArtisanArticles } from '@models/Artisan'

const ArticlesSection = forwardRef<HTMLElement>((_, ref) => {
  const { t } = useTranslation()
  const articles = useArtisanArticles()

  // SPでは縦長になるためblurのthresholdを0.2に設定
  return (
    <section className={style.section} ref={ref}>
      <MixBlendContainer>
        <BlurContainer threshold={0.2}>
          <div className={style.headline}>
            <ArtisanTopHeadline heading="Articles" />
            <div className={style.description}>
              <ArtisanTopDescription
                descriptionLines={[
                  t('artisan.articles1'),
                  t('artisan.articles2'),
                ]}
              />
            </div>
          </div>
        </BlurContainer>
      </MixBlendContainer>
      <ArtisanArticleList
        articles={articles.slice(0, 3)}
        gtmClickType="atrisan-latest"
      />
      <div className={style.link}>
        <JumpLink to="/artisan/articles">
          {t('artisan.articlesButton')}
        </JumpLink>
      </div>
    </section>
  )
})

export default ArticlesSection
